import React, { Component } from "react";
import { connect } from "react-redux";
import { FlightsList } from "./FlightsList";
import { changeTab } from "../actions";
import moment from "moment";
import { getLowestPrice, stretchTranslation, pad, stringDateToObjectDate } from "../shared/utils";
import { STRETCH_INBOUND, STRETCH_OUTBOUND } from "../shared/constants";

class TabFlightsWrapper extends Component {
	flightTabLabel(stretch) {
		if (this.props.selectedFlights[stretch].length > 0)
			return (
				<span className="select-tab-title">
					<span className="hidden-xs hidden-sm">Selecione o </span>voo de{" "}
					{stretchTranslation[stretch]}
				</span>
			);

		return (
			<span className="select-tab-title">
				<span className="hidden-xs hidden-sm">Selecione o </span>voo de{" "}
				{stretchTranslation[stretch]}
			</span>
		);
	}

	showAirportPrefix(stretch) {
		if (!stretch) return;

		if (stretch == STRETCH_INBOUND) return this.props.from;

		if (stretch == STRETCH_OUTBOUND) return this.props.to;
	}

	stretchPrice(stretch) {
		if (this.props.selectedFlights[stretch].length == 0) return;

		const selectedFlight = this.props.selectedFlights[stretch][0];
		let airlinePricing, milesPricing;

		milesPricing = selectedFlight.pricing
			? selectedFlight.pricing.miles ? selectedFlight.pricing.miles.adult.saleTotal : 0
			: 0;

		if (selectedFlight.otaAvailableIn == "both")
			airlinePricing =
				selectedFlight.pricing.airline !== null ? selectedFlight.pricing.airline.fareTotal : 0;
		else airlinePricing = 0;

		if (selectedFlight)
			return (
				<span className="select-tab-price">
					{selectedFlight.airline}
					<strong>
						{" "}
						R$ {parseFloat(this.props.selectedFlights[stretch][0].showPrice).toFixed(2)}
					</strong>
				</span>
			);
	}

	showFlightDate(stretchDate) {
		if (stretchDate) {
			return <span>{moment(stringDateToObjectDate(stretchDate)).format("ddd, DD, MMM")}</span>;
		}
	}

	render() {
		if (this.props && this.props.tripType == "RT") {
			return (
				<div className="tab-flights">
					<header
						data-action="flight-tab-selection-outbound"
						className={this.props.currentStretch == "outbound" ? "select-tab active" : "select-tab"}
						onClick={() => this.props.changeTab("outbound")}
					>
						{this.flightTabLabel("outbound")}

						{this.stretchPrice("outbound")}
					</header>

					<header
						data-action="flight-tab-selection-inbound"
						className={this.props.currentStretch == "inbound" ? "select-tab active" : "select-tab"}
						onClick={() => this.props.changeTab("inbound")}
					>
						{this.flightTabLabel("inbound")}

						{this.stretchPrice("inbound")}
					</header>
				</div>
			);
		}

		if (this.props && this.props.tripType == "OW") {
			return (
				<div className="tab-flights">
					<header className="select-tab active unique">
						{this.flightTabLabel("outbound")}

						{this.stretchPrice("outbound")}
					</header>
				</div>
			);
		}

		return null;
	}
}

const mapStateToProps = state => ({
	tripType: state.searchParams.params ? state.searchParams.params.tripType : "",
	inboundDate: state.searchParams.params ? state.searchParams.params.inboundDate : "",
	outboundDate: state.searchParams.params ? state.searchParams.params.outboundDate : "",
	formattedDate: state.searchParams.params ? new Date(state.searchParams.params.outboundDate) : "",
	from: state.searchParams.params ? state.searchParams.params.from : "",
	to: state.searchParams.params ? state.searchParams.params.to : "",
	currentStretch: state.flightsTab.currentStretch,
	selectedFlights: state.selectedFlights
});

const mapDispatchToProps = dispatch => ({
	changeTab: stretch => dispatch(changeTab(stretch))
});

export default connect(mapStateToProps, mapDispatchToProps)(TabFlightsWrapper);
